import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild,OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { User } from 'src/app/models/user';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { UserService } from 'src/app/services/user.service';
import { DateTimeService } from '../../services/date-time.service';
import { ModalService } from '../../services/modal.service';
import { SnackbarService } from '../../services/snackbar.service';
import { ErrorService } from '../../services/error.service';
import { SpinnerService } from '../../services/spinner.service';
import { FileService } from '../../services/file.service';
import { TrackParcelService } from '../../services/track-parcel.service';
import { ParcelUtilityService } from '../../services/parcel-utility.service';

@Component({
	selector: 'app-parcels',
	templateUrl: './parcels.html',
	styleUrls: ['./parcels.scss'],
	animations: [
		trigger('detailExpand', [
			state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
			state('*', style({ height: '*', visibility: 'visible' })),
			transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
		])
	]
})

export class ParcelsComponent implements OnInit, OnChanges, AfterViewInit,OnDestroy {
	public dataSource = new MatTableDataSource<any>();
	public dateTimeFormat: any;
	public displayedColumns: string[] = ['parcelId', 'barcode', 'masterBarcode', 'pieces', 'weight', 'parcelType', 'refrigerationType', 'action'];
	public page = 1;
	@ViewChild(MatPaginator) public paginator: MatPaginator;
	public parcelFilter = 'showAll';
	@Input() public parcels: any[] = [];
	@Input() public id: any;
	@Input() public type: string;
	@Input() public areParcelsEditable: boolean;
	@Output() public editParcel: EventEmitter<any> = new EventEmitter<any>();
	@Output() public addParcel: EventEmitter<void> = new EventEmitter<void>();
	public showAssignments: any;
	public user: User = new User();
	public subscriptions: any[] = [];
	public showAddAndEditButtons: boolean = false;

	constructor(private _dateTimeService: DateTimeService,
				private _userService: UserService,
				private _subscriptionService: SubscriptionService,
				private _modalService: ModalService,
				private _snackbarService: SnackbarService,
				private _errorService: ErrorService,
				private _spinnerService: SpinnerService,
				private _fileService: FileService,
				private trackParcelService: TrackParcelService,
				private _parcelUtilityService: ParcelUtilityService) {
	}

	calcTotals(parcels) {
		parcels.forEach((parcel) => {
			parcel.assignments.forEach((assignment) => {
				let total = 0;
				if (assignment.items) {
					assignment.items.forEach((item) => total = total + item.quantity);
				}
				assignment.itemTotal = total;
			});
		});
	}

	filterParcels(value) {
		this.parcelFilter = value;
		switch (value) {
			case 'showAll': {
				this.dataSource.data = this.parcels;
				break;
			}
			case 'scanned': {
				this.dataSource.data = this.parcels.filter((parcel) => {
					return parcel.assignments.find((assignment) => (this.type === 'ONDEMAND' || assignment.parcelParentId === this.id) &&
						assignment.scannedWhen !== null);
				});
				break;
			}
			case 'over': {
				this.dataSource.data = this.parcels.filter((parcel) => {
					return parcel.assignments.find((assignment) => (this.type === 'ONDEMAND' || assignment.parcelParentId === this.id) &&
						(assignment.creationType === 'FieldScan' || assignment.creationType === 'FIELDSCAN'));
				});
				break;
			}
			case 'short': {
				this.dataSource.data = this.parcels.filter((parcel) => {
					const assignments = parcel.assignments.filter((assignment) => (this.type === 'ONDEMAND' || assignment.parcelParentId === this.id) &&
						assignment.scannedWhen !== null);
					return assignments.length === 0;
				});
				break;
			}
			default:
				this.dataSource.data = this.parcels;
				break;
		}
	}

	ngAfterViewInit(): void {
		this.dataSource.paginator = this.paginator;
	}

	ngOnChanges(changes: SimpleChanges) {
		this.filterParcels(this.parcelFilter);
	}

	ngOnInit(): void {
		this.dateTimeFormat = this._dateTimeService.getDateTime();
		if (this.parcels) {
			this.calcTotals(this.parcels);
		}
		this.subscriptions.push(this._userService.user$.subscribe((data) => {
			this.user = data;
			this.showAddAndEditButtons = (this.type === 'ONDEMAND' && this.user?.editOrderValue !== 'NEVER') || (this.type === 'ROUTESTOP' && this.user?.inetUser?.modifyRouteStopParcels);
		}));
	}

	ngOnDestroy(): void {
		this._subscriptionService.unSubscribe(this.subscriptions);
	}

	stopPropagation(e): void {
		e.stopPropagation();
	}

	handelEditParcel(parcel) {
		this.editParcel.emit(parcel);
	}

	handelAddParcel() {
		this.addParcel.emit(this.id);
	}

	handelEmailParcel(parcelId) {
		this._parcelUtilityService.emailParcel(parcelId);
	}

	handelPrintParcel(parcelId) {
		this._parcelUtilityService.printParcel(parcelId);
	}
}
